const authorAvatarStyles = {
  width: '24px',
  height: '24px',
  fontSize: '1rem',
  fontWeight: 500,
};

export const getAuthorAvatarBorderStyles = borderColor => ({
  ...authorAvatarStyles,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: ({ palette }) => borderColor || palette.border.input,
});

export const authorAvatarWithBorderStyles = {
  ...getAuthorAvatarBorderStyles(),
  flexShrink: 0,
};
